import { Heading3 } from 'components/shared/Typography';
import styled from 'styled-components';
import { container, fontSize, spacing } from '../../../theme';

export const StyledCta = styled.div`
  max-width: ${container('md')};
  margin: ${spacing('xl4')} auto;
  text-align: center;

  ${Heading3} {
    margin-bottom: ${spacing('md')};
  }

  > p {
    font-size: ${fontSize('lg')};
  }
`;

export const StyledActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${spacing('lg')};
  margin-top: ${spacing('xl')};

  > * {
    flex-basis: 75%;
  }

  @media (min-width: ${container('md')}) {
    flex-direction: row;
  }
`;
